.root {
  position: relative;
  margin-bottom: 2rem;
}

@media (min-width: 768px) {
  .root {
    margin-bottom: 4rem;
  }
}

.horizontalRule {
  border-top-width: 1px;
}